export default __webpack_public_path__ + "static/media/me.6d43cf40.PNG";